import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="flag">🇯🇲</span>
              <span>MELISSAJAMAICA.ORG</span>
            </div>
            <p>AI-Powered Hurricane Recovery</p>
            <p className="footer-tagline">A project of ENVIROTEK Group</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#climate-data" onClick={(e) => scrollToSection(e, 'climate-data')}>Dashboard</a></li>
              <li><a href="#about" onClick={(e) => scrollToSection(e, 'about')}>About</a></li>
              <li><a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="#map">Damage Map</a></li>
              <li><a href="#dashboard">Dashboard</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <button type="button" onClick={() => alert('Facebook page coming soon!')}>Facebook</button>
              <button type="button" onClick={() => alert('Twitter page coming soon!')}>Twitter</button>
              <button type="button" onClick={() => alert('Instagram page coming soon!')}>Instagram</button>
              <button type="button" onClick={() => alert('LinkedIn page coming soon!')}>LinkedIn</button>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Melissa Jamaica. All rights reserved.</p>
          <p>Built with ❤️ for Jamaica | Powered by AI for Good</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
